import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import './ItemCategory.scss';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"; 
import MaterialTable from '../../Components/DataTable/DataTable';
import { CSVLink } from "react-csv";
import { withRouter } from 'react-router-dom';
import AddBoxIcon from "@material-ui/icons/AddBox"; 
import Dialog  from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Table,
	TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
  import { makeStyles } from "@material-ui/core/styles"; 

import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';
import { validateItemCategoryRows } from '../formValidation';
 class ItemCategory extends React.Component {

  handleLinkEditClick = (item,action) => {
    this.setShowEdit(true);
    this.setState({currentCategoryId:item.CategoryId});
    this.setState({currentCategoryName:item.CategoryName});
    this.setState({currentCategoryCode:item.CategoryCode});
     this.setState({currentStartingFrom:item.StartingId});
    this.setState({currentIncrementBy:item.IncrementBy});
    this.setState({currentEndingNumber: item.EndingNumber != null && item.EndingNumber !== '' ? item.EndingNumber : ''});
    this.setState({currentEntityGroupId: item.EntityGroupId != null ? item.EntityGroupId : ''});
  };

  handleEditName = () => {
    const validationError = validateItemCategoryRows([{
      categoryname: this.state.currentCategoryName,
      categorycode: this.state.currentCategoryCode,
      startingid: this.state.currentStartingFrom,
      incrementby: this.state.currentIncrementBy,
      endingnumber: this.state.currentEndingNumber,
    }]);
    if (validationError) {
      this.setState({ errorMessage: validationError, successMessage: null });
      this.props.showFlashNotification(validationError, 'error');
      return;
    }
   let user = JSON.parse(sessionStorage.getItem('user'));
            let accessToken = user.accessToken;
          apiClient.post(`/api/post/itemCategoryUpdate`, { categoryName:this.state.currentCategoryName,categoryCode:this.state.currentCategoryCode,startingId:this.state.currentStartingFrom,incrementBy:this.state.currentIncrementBy,endingNumber:this.state.currentEndingNumber,entityGroupId:this.state.currentEntityGroupId,categoryId:this.state.currentCategoryId }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
            .then(res => {
            
              this.setState({ successMessage: 'Successfully saved!' });
        
              setTimeout(() => {
                this.setState({ successMessage: null });
                sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
                  const { history } = this.props;
                  history.push('/vendor-details');
                    setTimeout(() => {
                      history.push('/item-category');
                    }, 1); 
               
              }, 3000);
              this.setShowEdit(false);
            })
            .catch(error => notifyApiError(
              this.props.showFlashNotification,
              error,
              'Unable to update item category.'
            ));
           
        }

        

        setShowBarCode= (state) => {
    
          this.setState({showBarCode:state});
         
        };
    

  setShowEdit= (state) => {
    
    this.setState({showEdit:state});
   
  };

  handleLinkBarCodeClick = (item,action) => {
    this.generateBarcode(item);
    this.setState({selectedItem:item});
    this.setShowBarCode(true);
  };

  useStyles = makeStyles({ 
    root: { 
      "& > *": { 
        borderBottom: "unset", 
      }, 
    }, 
    
    snackbar: { 
      bottom: "104px", 
    }, 
    table: {
      maxWidth: '100%', // Set to '100%' to make the table responsive
      },
      tableHeader: {
      backgroundColor: '#f2f2f2',
      fontWeight: 'bold',
      },
      tableRow: {
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
      },
      tableCell: {
      borderBottom: '1px solid #dddddd',
      width:"150px !important",
      },
      rowDiv: {
      width:"1000px !important",
      },
      dialogCustom:{
      width:"800px !important",
      height:"600px !important",
      },
      divRight:{
      float:"right"
      }
      ,
      divLeft:{
      float:"left"
      }
  }); 

   
    state = {
      barcodeSrc:'',
        Results: [],
        selectedItem:null,
        showBarCode:false,
        showEdit:false,
        currentCategoryId:0,
        currentCategoryName:"",
        currentCategoryCode:"",
        currentStartingFrom:0,
        currentIncrementBy:0,
        currentEndingNumber:'',
        currentEntityGroupId:'',
        fullWidth:true,
        noOfPrint:null,
        maxWidth:'sm',
        columns: [
          
          { title: '', field: 'CategoryId' ,
            render: rowData => (
              <a
                href="javascript:void(0)"
                onClick={() => this.handleLinkEditClick(rowData,'edit')}
              >
                {'Edit'}
              </a>
            )
          
          },
          
          { title: "Category Name", field: "CategoryName" },
            { title: 'Category Code', field: 'CategoryCode' },
            { title: 'Starting From', field: 'StartingId' },
            { title: 'Increment By', field: 'IncrementBy' },
            { title: 'Current Id', field: 'CurrentId' },
            { title: 'Ending Number', field: 'EndingNumber' },
            { title: 'Entity Group', field: 'EntityGroupName' }
        ],
        headers: [
          { label: "Category Name", key: "CategoryName" },
          { label: "Category Code", key: "CategoryCode" },
          { label: "Starting From", key: "StartingId" },
          { label: "Increment By", key: "IncrementBy" },
          { label: "Current Id", key: "CurrentId" },
          { label: "Ending Number", key: "EndingNumber" },
          { label: "Entity Group", key: "EntityGroupName" }
        ],
        vendorList: [],
        categoryList: [],
        entityGroups: [],
        formData: {
            itemCategory: '',
            categoryCode: '',
            startingFrom: '',
            incrementBy: '',
            endingNumber: ''
        },
        submitted: false,
        successMessage:null,
        errorMessage:null,
        index:0,
        IsAdded:false,
        rows:[],
        edit:false,
        disable:false,
       showConfirm:false,
       rowIndex:0
    }

     handlePrintBarcode = () => {
      const printWindow = window.open('', '_blank');
      const barcodeHtml = Array.from({ length:this.state.noOfPrint }).map(() => `
      <div class="label" id="barcodeHtml" style="height:1in;width:2in;margin:10px;float:left">
        <img style="max-width:100%;max-height:100%;" src="${this.state.barcodeSrc}" alt="Barcode for 12345" />
      </div>
      
    `).join('');


printWindow.document.write(`
  <html>
    <head><title>Print Labels</title></head>
    <body style="margin:100px" onload="window.print(); window.close();">
      ${barcodeHtml}
    </body>
  </html>
`);
printWindow.document.close();
printWindow.focus();

   
    };
  

    componentDidMount() {
     
     
let ItemTabIndex = JSON.parse(sessionStorage.getItem('ItemTabIndex'));
if(ItemTabIndex == '1')
{
   this.setState({
    index: 1,
   });

}

      sessionStorage.setItem('TranSearch', null);
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = getAccessToken();
  
      
          apiClient.get(`/api/get/itemcategory`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const Results = res.data;
            this.setState({ Results });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load item categories.'
          ));
          apiClient.get(`/api/get/entitygroup`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            this.setState({ entityGroups: res.data || [] });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load entity groups.'
          ));
  
          
         if(user.permissions.filter(x=>x.PermissionName == 'Inventory' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }
      }

      handleNo = () => { 
        this.setState({showConfirm:false}); 
      }; 

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleInputChangePrintLabel = (e) => { 
      this.setState({noOfPrint:e.target.value}); 
    }; 

    handleInputChangeCategoryName = (e) => { 
      this.setState({currentCategoryName:e.target.value}); 
    }; 

     handleInputChangeCategoryCode = (e) => { 
      this.setState({currentCategoryCode:e.target.value}); 
    }; 

     handleInputChangeStartingFrom = (e) => { 
      this.setState({currentStartingFrom:e.target.value}); 
    }; 

     handleInputChangeIncrementBy = (e) => { 
      this.setState({currentIncrementBy:e.target.value}); 
    }; 

     handleInputChangeEndingNumber = (e) => { 
      this.setState({currentEndingNumber:e.target.value}); 
    }; 

    lastRowCategoryValid = (row) => {
      if (!row) return false;
      const start = Number(row.startingid);
      const incr = Number(row.incrementby);
      const end = Number(row.endingnumber);
      return row.categoryname !== '' && row.categorycode !== '' && start > 0 && incr > 0 && !Number.isNaN(end) && end > 0 && end >= start;
    };

    handleSubmit = () => {
      const validationError = validateItemCategoryRows(this.state.rows);
      if (!validationError)
        {

          let user = JSON.parse(sessionStorage.getItem('user'));
          let accessToken = user.accessToken;
    
          const { location } = this.props;
          const pathname = location.pathname;
          const pageName = pathname.substring(1);
                    apiClient.post(`/api/post/itemcategories`,  this.state.rows , { headers: {"Authorization" : `Bearer ${accessToken}`} })
                  .then(res => {
                      const result = res.data;
                      this.setState({ result });
                    this.setState({ successMessage: 'Successfully saved!' });
                    setTimeout(() => {
                      this.setState({ successMessage: null });
                      if(pageName == 'item-category')
                      {
                       
                        const { history } = this.props;
                        history.push('/vendor-details');
                          setTimeout(() => {
                            history.push('/item-category');
                          }, 1); 
                      }
                    }, 3000);
                  })
                  .catch(error => notifyApiError(
                    this.props.showFlashNotification,
                    error,
                    'Unable to save item categories.'
                  ));
            }else{
              this.setState({ errorMessage: validationError, loading: false });
              this.props.showFlashNotification(validationError, 'error');
              setTimeout(() => this.setState({errorMessage:null}), 10000);
            }
    }


    handleRemoveClick = (i) => { 
      const list = [...this.state.rows]; 
      this.setState({rows:null});
      let listNew = list.filter(x=>x.id !== (this.state.rowIndex)); 
      this.setState({rows:listNew}); 
      this.setState({showConfirm:false}); 
      this.setState({addItem:false});
    }; 

    handleConfirm = (index) => { 
      this.setState({showConfirm:true}); 
      this.setState({rowIndex:index});
    }; 

    handleCategoryChange = (e, index) => { 
      const list = [...this.state.rows]; 
      list[index]['categoryId'] = e.target.value;
      this.setState({rows:list}); 
			
    };

    handleInputChange = (e, index,type='') => { 
      this.setState({disable:false}); 
        const { name, value } = e.target; 
        const list = [...this.state.rows]; 
        list[index][name] = value;
        this.setState({rows:list}); 
    }; 

    setBarCode = (action) => {
      
      this.setState({ showBarCode: action });
     
    };

    setEdit = (action) => {
      
      this.setState({ showEdit: action });
     
    };


    handleAdd = () => { 

      if(this.state.rows.length == 0)
      {
        this.setState({IsAdded:true});
        this.setState({rows:[ 
          ...this.state.rows, 
          { 
            id: this.state.rows.length + 1,  
            itemid: '',categoryId:0,categoryname:'', categorycode: '',startingid:0,incrementby:0,endingnumber:0,entityGroupId:''
          }, 
        ]}); 
        this.setState({edit:true}); 

      }
      else{

         if( this.lastRowCategoryValid(this.state.rows[this.state.rows.length - 1]) )
        {
          this.setState({IsAdded:true});
        this.setState({rows:[ 
          ...this.state.rows, 
          { 
            id: this.state.rows.length + 1,  
            itemid: '',categoryId:0,categoryname:'', categorycode: '',startingid:0,incrementby:0,endingnumber:0,entityGroupId:''
          }, 
        ]}); 
        this.setState({edit:true}); 
    }else{
    
          var errorMsg = 'In last item added, Following fields need to be checked ';
          
          
           if(this.state.rows[this.state.rows.length - 1].categoryname == '' )
              {
                errorMsg += 'Category Name. \r\n';
              }

              if(this.state.rows[this.state.rows.length - 1].categorycode == '' )
              {
                errorMsg += 'Category Code. \r\n';
              }

              if(this.state.rows[this.state.rows.length - 1].startingid == 0  )
              {
                errorMsg += 'Starting From should be greater than 0. \r\n';
              }

             if(this.state.rows[this.state.rows.length - 1].incrementby == 0  )
              {
                errorMsg += 'Increment by should be greater than 0. \r\n';
              }

              const endN = Number(this.state.rows[this.state.rows.length - 1].endingnumber);
              const startN = Number(this.state.rows[this.state.rows.length - 1].startingid);
              if (Number.isNaN(endN) || endN <= 0) {
                errorMsg += 'Ending Number should be greater than 0. \r\n';
              } else if (endN < startN) {
                errorMsg += 'Ending Number should be greater than or equal to Starting From. \r\n';
              }
              

          errorMsg += '. Pls fill out the required fields.';
          
          setTimeout(() => {
            this.setState({errorMessage:errorMsg});
          }, 1000);
           
          setTimeout(() => {
            this.setState({errorMessage:null});
           
            this.setState({loading:false});   
        }, 10000);    
        }
      }     
    }; 

    handleChildClick = () => {
      this.props.onSendValue();
      };

      a11yProps(index) {
        return {
          id: `scrollable-auto-tab-${index}`,
          'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
      }
      onTabClicked = (event, newValue) => {
        this.setState({ index: newValue });
    }

   

    render() {

        const { submitted } = this.state;
        return (
      <div className="ItemCategory">
                <h2>Item Category</h2>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}> 
                <div> 
                      <div className="alignDiv">
                        <Button onClick={this.handleAdd}> 
                        <AddBoxIcon onClick={this.handleAdd} /> 
                        ADD 
                        </Button> 
                        </div>
                </div> 

                </div> 
                <div style={{  marginTop:"10px" }}>
                    <Table  className="" 
                        size="small"
                        aria-label="a dense table"
                        > 
                            <TableHead> 
                                  <TableRow className="" > 
                                        <TableCell className=""  align="center">Category Name</TableCell> 
                                        <TableCell className=""  align="center">Category Code</TableCell> 
                                        <TableCell className=""  align="center">Starting From</TableCell> 
                                        <TableCell className=""  align="center">Increment By</TableCell> 
                                        <TableCell className=""  align="center">Ending Number</TableCell> 
                                        <TableCell className=""  align="center">Entity Group</TableCell>
                                        <TableCell className=""  align="center"></TableCell> 
                                  </TableRow> 
                            </TableHead> 
                            <TableBody> 
                                            {this.state.rows.map((row, i) => {   
                                            return ( 
                                                    <TableRow className=""  > 
                                                    <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="text"
                                                          value={row.categoryname} 
                                                          name="categoryname"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                    <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="text"
                                                          value={row.categorycode} 
                                                          name="categorycode"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                   <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="number"
                                                          value={row.startingid} 
                                                          name="startingid"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                 <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="number"
                                                          value={row.incrementby} 
                                                          name="incrementby"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                 <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="number"
                                                          value={row.endingnumber} 
                                                          name="endingnumber"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                    <TableCell padding="none" style={{ textAlign: 'left' }}>
                                                      <Select
                                                        displayEmpty
                                                        value={row.entityGroupId || ''}
                                                        name="entityGroupId"
                                                        onChange={(e) => this.handleInputChange(e, i)}
                                                        style={{ minWidth: 150 }}
                                                      >
                                                        <MenuItem value=""><em>None</em></MenuItem>
                                                        {this.state.entityGroups.map((group) => (
                                                          <MenuItem key={group.EntityGroupId} value={group.EntityGroupId}>
                                                            {group.EntityGroupName}
                                                          </MenuItem>
                                                        ))}
                                                      </Select>
                                                    </TableCell>

                                                  <TableCell  className="" 
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                        >
                                                          <Button className="mr10" onClick={(e) =>this.handleConfirm(row.id)}> 
                                                              <DeleteOutlineIcon /> 
                                                            </Button> 
                                                    </TableCell> 
                                                
                                                          {this.state.showConfirm && ( 
                                                              <div> 
                                                                <Dialog 
                                                                open={this.state.showConfirm} 
                                                                onClose={this.handleNo} 
                                                                aria-labelledby="alert-dialog-title"
                                                                aria-describedby="alert-dialog-description"
                                                                > 
                                                                <DialogTitle id="alert-dialog-title"> 
                                                                  {"Confirm Delete"} 
                                                                </DialogTitle> 
                                                                <DialogContent> 
                                                                  <DialogContentText id="alert-dialog-description"> 
                                                                  Are you sure to delete
                                                                  </DialogContentText> 
                                                                </DialogContent> 
                                                                <DialogActions> 
                                                                  <Button 
                                                                  onClick={() => this.handleRemoveClick()}
                                                                  color="primary"
                                                                  autoFocus 
                                                                  > 
                                                                  Yes 
                                                                  </Button> 
                                                                  <Button 
                                                                  onClick={this.handleNo} 
                                                                  color="primary"
                                                                  autoFocus 
                                                                  > 
                                                                  No 
                                                                  </Button> 
                                                                </DialogActions> 
                                                                </Dialog> 
                                                              </div> 
                                                            )} 
                                                      </TableRow> 
                                              
                                                ); 
                                            })} 
                            </TableBody> 
                    </Table> 
                    <br /><br /><br />
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={this.handleSubmit}
                      
                        disabled={submitted}
                    >
                        {
                            (submitted && 'Your form is submitted!')
                            || (!submitted && 'Submit')
                        }
                    </Button>

                    {this.state.successMessage && (
              <div
                style={{
                  backgroundColor: '#28a745',
                  color: '#fff',
                  padding: '10px',
                  marginTop: '10px',
                }}
              >
                {this.state.successMessage}
              </div>
            )}

    {this.state.errorMessage && (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
                </div>
                
                
              
   

    <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
    <div style={{textAlign:'right', paddingBottom: '3px'}}>
    <CSVLink data={this.state.Results} headers={this.state.headers}>
    Export to Excel
    </CSVLink>

    </div>
    <MaterialTable
    columns={this.state.columns}
    data={this.state.Results}
    title="Item Categories"
    />


    </div>

   {this.state.showEdit && ( 
					<div> 
						<Dialog  
						  fullWidth={this.state.fullWidth}
						  maxWidth={this.state.maxEditWidth}
						open={this.state.showEdit} 
						onClose={() => this.setEdit(false)} 
						> 
            <DialogTitle id="alert-dialog-title"> 
						<div style={{float:"left"}}><h4>Edit Item Category</h4></div>
						<div style={{float:"right"}}>
						<IconButton
								aria-label="close"
								onClick={() => this.setShowEdit(false)}
								sx={{
									position: "fixed",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
					
						<DialogContent id="alert-dialog-description"> 
							<DialogContentText > 
                <div className="row mt-5" >
                    
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"50px"}}>
                        <label>Category Name</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="text"
                            value={this.state.currentCategoryName} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangeCategoryName(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"50px"}}>
                        <label>Category Code</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="text"
                            value={this.state.currentCategoryCode} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangeCategoryCode(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"55px"}}>
                        <label>Starting From</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="number"
                            value={this.state.currentStartingFrom} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangeStartingFrom(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"55px"}}>
                        <label>Increment By</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="number"
                            value={this.state.currentIncrementBy} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangeIncrementBy(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"55px"}}>
                        <label>Ending Number</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="number"
                            value={this.state.currentEndingNumber} 
                            name="endingNumber"
                            onChange={(e) => this.handleInputChangeEndingNumber(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"55px"}}>
                        <label>Entity Group</label>
                    </div>
                    <div class="col-md-7">
                    <Select
                      displayEmpty
                      value={this.state.currentEntityGroupId || ''}
                      onChange={(e) => this.setState({ currentEntityGroupId: e.target.value })}
                      style={{width:"250px"}}
                    >
                      <MenuItem value=""><em>None</em></MenuItem>
                      {this.state.entityGroups.map((group) => (
                        <MenuItem key={group.EntityGroupId} value={group.EntityGroupId}>
                          {group.EntityGroupName}
                        </MenuItem>
                      ))}
                    </Select>
                    </div>
                    </div>
                    <br/>
                    <br/>
                    <div class="row mt-5"  style={{textAlign:"center"}}>
                        <div class="col-md-6 mr-1" style={{textAlign:"center",float:"left",marginRight:"2px"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={this.handleEditName} > 
                                                                               Save
                                                                                </Button> 
                        </div>
                        <div class="col-md-6" style={{textAlign:"center",float:"left"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={() => this.setShowEdit(false)} > 
                                                                                Close
                                                                                </Button> 
                        </div>
                    </div>
                </div>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
						</DialogActions> 
						</Dialog> 
            
					</div> 
					)}
      </div>
        );
    }
}
export default withRouter(withFlashNotification(ItemCategory));
